import { render, staticRenderFns } from "./contract-gather.vue?vue&type=template&id=4c2785f9&scoped=true&"
import script from "./contract-gather.vue?vue&type=script&lang=js&"
export * from "./contract-gather.vue?vue&type=script&lang=js&"
import style0 from "./contract-gather.vue?vue&type=style&index=0&id=4c2785f9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c2785f9",
  null
  
)

export default component.exports